import React from 'react'
import { Link } from 'react-router-dom'
import { PrivacyContent } from './legal/LegalContents'

export default function PrivacyPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-10">
      <div className="flex items-center justify-between gap-4">
        <h1 className="text-2xl font-bold text-slate-900">개인정보 처리방침</h1>
        <Link className="text-sm text-slate-600 hover:text-brand-sky" to="/login">
          로그인으로 돌아가기
        </Link>
      </div>

      <div className="mt-2 text-sm text-slate-500">버전: 2026-01-12</div>

      <div className="mt-6">
        <PrivacyContent />
      </div>
    </div>
  )
}

